import { logger } from "@rpldy/shared";
import createChunkedSender from "./chunkedSender";
export default (options => {
  //return uploader enhancer
  return (uploader, trigger) => {
    const sender = createChunkedSender(options, trigger);
    logger.debugLog("chunkedSenderEnhancer: Created chunked-sender instance with options: ", options);
    uploader.update({
      send: sender.send
    });
    return uploader;
  };
});